import { Grid } from '@material-ui/core'
import { Filter, TextField, useFilter } from 'elentari'
import React from 'react'
import { Field } from 'react-final-form'
import NumberFormatInput from '../../components/NumberFormatInput'
import { RiscoAutocomplete } from '../Riscos/components/RiscoAutocomplete'

export const CenarioFilter = () => {
  const { onSubmit, ...filter } = useFilter({})

  const handleSubmit = async data => {
    if (!data.valorInicialDe) delete data.valorInicialDe
    if (!data.valorInicialAte) delete data.valorInicialAte

    if (!data.valorFinalDe) delete data.valorFinalDe
    if (!data.valorFinalAte) delete data.valorFinalAte

    onSubmit(data)
  }

  return (
    <Filter
      {...filter}
      onSubmit={handleSubmit}
      labels={{ find: 'Buscar', clear: 'Limpar' }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <NumberFormatInput
            label="Valor inicial de"
            name="valorInicialDe"
            fullWidth
            allowNull
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <NumberFormatInput
            label="Valor inicial até"
            name="valorInicialAte"
            fullWidth
            allowNull
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <NumberFormatInput
            label="Valor final de"
            name="valorFinalDe"
            fullWidth
            allowNull
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <NumberFormatInput
            label="Valor final até"
            name="valorFinalAte"
            fullWidth
            allowNull
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição do cenário"
            component={TextField}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Field
            fullWidth
            name="riscoId"
            label="Risco"
            component={RiscoAutocomplete}
          />
        </Grid>
      </Grid>
    </Filter>
  )
}
